import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  description: {
    id: 'proforma-form-system.src.ui.form-card-index.form-card.form-card-body.permission-error.title',
    defaultMessage: 'Only specific people can view this form.',
    description: 'Error message shown when a user does not have permissions to view the form.'
  }
});